import React from "react";
import '../../assets/css/buttons/BlueButton.css';


const BlueButton = ({setTrue, setFalseArr, onClickDo, fancyBorder=true, children}) => {
    const doSets = () => {
        console.log("doing sets");
        
        if(setTrue) {
            setTrue(true);  
        }
        
        if(setFalseArr && Array.isArray(setFalseArr)) {
            setFalseArr.forEach(setFalse => {
                setFalse(false);
            });
        }
    }

    return (
        <button 
        className={"flex flexCenter bigBlueButton " + (fancyBorder ? "fancyBlueBorder" : "regularBlueBorder")} 
        type="button" 
            onClick={(e) => {
                if(onClickDo) {
                    onClickDo(e);
                }
                doSets();
            }}
        >
            {children}
        </button>
    );
}

export default BlueButton